// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d3615348","455":"f99248a1","644":"3d72603f","867":"c3fb8bdf"}[chunkId] + ".chunk.js";
};